import { BUY_GET_DISCOUNT_LOYALTY_RULE_GROUP, DISCOUNTS, splitPrice } from 'chemistry'

const getFreeDiscountTranslationKeyByQuantity = promotion => {
  const { qualifiedQuantity, actionQuantity, sameProducts } = promotion
  const totalAmount = parseInt(actionQuantity, 10) + parseInt(qualifiedQuantity, 10)

  // 1+1 discount
  if (qualifiedQuantity === 1 && actionQuantity === 1) {
    const suffix = sameProducts ? '' : '_combo'

    return { key: `koop_1_artikel_en_krijg_het_2_artikel_gratis${suffix}`, params: {} }

    // X+Y, where x>1 AND y=1
  } else if (qualifiedQuantity > 1 && actionQuantity === 1) {
    return {
      key: 'Koop_X_artikelen_en_krijg_1_artikel_gratis',
      params: {
        totalAmount
      }
    }

    // X+Y, where x=1 AND y>1
  } else if (qualifiedQuantity === 1 && actionQuantity > 1) {
    return {
      key: 'koop_1_artikel_en_krijg_Y_artikelen_gratis',
      params: {
        freeAmount: actionQuantity,
        totalAmount
      }
    }
  }

  // X+Y, where x>1 AND y>1
  return {
    key: 'koop_X_artikelen_en_krijg_Y_artikelen_gratis',
    params: {
      freeAmount: actionQuantity,
      totalAmount
    }
  }
}

const freeDiscountTranslation = (promotion, t) => {
  const { key, params } = getFreeDiscountTranslationKeyByQuantity(promotion)
  const isCardHolder = promotion.promotionGroup === BUY_GET_DISCOUNT_LOYALTY_RULE_GROUP
  const translation = t(key, params)

  if (isCardHolder) {
    return `${translation} ${t('met_praxis_plus')}`
  }

  return translation
}

const halfPriceDiscountTranslation = (promotion, t) => {
  const { actionQuantity, qualifiedQuantity, sameProducts } = promotion
  const suffix = sameProducts ? '' : '_combo'
  const translationKey = `krijg_het_Y_artikel_voor_de_halve_prijs${suffix}`

  return t(translationKey, { amount: actionQuantity + qualifiedQuantity })
}

const togetherCheaperPercentageDiscount = (promotion, t) => {
  const { amount, actionQuantity, qualifiedQuantity, sameProducts } = promotion
  const suffix = sameProducts ? '' : '_combo'
  const translationKey = `krijg_XX%_korting_op_je_Y_artikel${suffix}`

  return t(translationKey, { amount, itemQuantity: actionQuantity + qualifiedQuantity })
}

const wholesaleDiscount = (promotion, t) => {
  const { amount, actionQuantity, qualifiedQuantity, bundlePrice } = promotion
  if (qualifiedQuantity !== actionQuantity) return null
  const { euro, dime } = splitPrice(bundlePrice || qualifiedQuantity * amount)
  return t('krijg_X_artikelen_voor_YYY_euro', { amount: qualifiedQuantity, cost: `${euro},${dime}` })
}

export const getEqualBannerTitleByType = (type, promotion, t) => {
  switch (type) {
    case DISCOUNTS.FREE:
      return freeDiscountTranslation(promotion, t)
    case DISCOUNTS.HALF_PRICE:
      return halfPriceDiscountTranslation(promotion, t)
    case DISCOUNTS.WHOLESALE:
      return wholesaleDiscount(promotion, t)
    case DISCOUNTS.TOGETHER_CHEAPER_PERCENTAGE:
      return togetherCheaperPercentageDiscount(promotion, t)
    default:
      return null
  }
}
